var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOficinas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.343,
    height: 51.525,
    viewBox: "0 0 51.343 51.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .home-participante-oficinas-a{fill:#fff}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.904)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.904 33.269)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "home-participante-oficinas-a",
    d: "M47.341,339.87a5.816,5.816,0,1,0-9.339.007,8.184,8.184,0,0,0-3.377,2.742,8.184,8.184,0,0,0-3.392-2.749,5.816,5.816,0,1,0-9.339.007,8.184,8.184,0,0,0-3.372,2.734,8.184,8.184,0,0,0-3.387-2.741,5.816,5.816,0,1,0-9.339.007A8.148,8.148,0,0,0,.9,347.337v1.514H52.247v-1.514A8.148,8.148,0,0,0,47.341,339.87Z",
    transform: "translate(-0.904 -330.595)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.225 9.917)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "home-participante-oficinas-a",
    d: "M173.819,106.052l-6.421-2.03-3.915-5.479-3.915,5.479-6.421,2.03,4,5.416L157.1,118.2l6.388-2.132,6.388,2.132-.053-6.734Z",
    transform: "translate(-153.148 -98.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.067)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "home-participante-oficinas-a",
    width: 3.027,
    height: 4.335
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.333 18.211)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "home-participante-oficinas-a",
    width: 4.335,
    height: 3.027
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.494 18.211)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "home-participante-oficinas-a",
    width: 4.335,
    height: 3.027
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.021 4.295)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "home-participante-oficinas-a",
    width: 5.05,
    height: 3.027,
    transform: "translate(0 3.571) rotate(-45)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.408 4.275)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "home-participante-oficinas-a",
    width: 3.027,
    height: 5.05,
    transform: "translate(0 2.141) rotate(-45)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOficinas);
export default __webpack_public_path__ + "static/media/icon-oficinas.c0100af0.svg";
export { ForwardRef as ReactComponent };